import { Plus } from "@phosphor-icons/react"
import { Button } from "@vesatogo/grass-core"
import React from "react"

interface ProductionSectionProps {
  title: string
  colorScheme: "green" | "blue" | "orange"
  stats?: { items: number; qty: number; cost: number }
  onAddCommodity: () => void
  children: React.ReactNode
  commodityLabel?: string
  disableAdd?: boolean
}

const ProductionSection = ({
  title,
  colorScheme,
  stats,
  onAddCommodity,
  children,
  commodityLabel = "Commodity",
  disableAdd,
}: ProductionSectionProps) => {
  const colors = {
    green: {
      border: "border-[#00A63E]",
      bg: "bg-green-50",
      text: "text-[#00A63E]",
    },
    blue: {
      border: "border-[#155DFC]",
      bg: "bg-blue-50",
      text: "text-[#155DFC]",
    },
    orange: {
      border: "border-[#FF9000]",
      bg: "bg-orange-50",
      text: "text-[#FF9000]",
    },
  }[colorScheme]

  return (
    <div>
      <div
        className={`p-2 flex justify-between items-center border-l-4 rounded-sm ${colors.border}`}
      >
        <div className={`flex flex-col gap-1  font-bold  px-2`}>
          <span className={` ${colors.text}`}>{title}</span>
          {stats && (
            <div className="flex gap-4 text-xs">
              <span>{stats.items || 0} items</span>
              <span>{stats.qty || 0} kg</span>
              <span className={` ${colors.text}`}>₹ {stats.cost || 0}</span>
            </div>
          )}
        </div>
        <div className="flex gap-4 items-center">
          <Button
            variant="ghost"
            leftIcon={<Plus size={14} />}
            onClick={onAddCommodity}
            disabled={disableAdd}
          >
            {commodityLabel}
          </Button>
        </div>
      </div>
      <div className="my-4 bg-white">{children}</div>
    </div>
  )
}

export default ProductionSection
